/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


function modifySubscriptionLink() {
  const links = document.querySelectorAll('a[title="Manage Subscriptions"]');
  links.forEach(link => {
    link.target = '_blank';
    link.textContent = 'Meine Abonnements';
  });
}

function modifyGiftCardLink() {
  const links = document.querySelectorAll('a');
  for (let i = 0; i < links.length; i++) {
    if (links[i].textContent.trim() === 'Meine Geschenkkarten') {
      links[i].textContent = 'Meine Giftcards';
      break;
    }
  }
}

function injectSidebarToSubscriptions() {
  if (window.location.pathname.includes('/apps/subscription-customer/customer-portal/')) {
    const targetElement = document.querySelector('.utterbond-subscriptions.ub-customer-portal');
    if (targetElement) {
      // Create wrapper
      const wrapper = document.createElement('div');
      wrapper.className = 'subscription-portal-wrapper';
      
      // Wrap the target element
      targetElement.parentNode.insertBefore(wrapper, targetElement);
      wrapper.appendChild(targetElement);
      
      // Create sidebar
      const sidebar = document.createElement('aside');
      sidebar.className = 'account-sidebar subscription-injected-sidebar';
      sidebar.innerHTML = `
        <div class="desktop">
          <p class="account-sidebar__title strong">Mein Konto</p>
          <ul>
            <li><a href="/account">Bestellungen</a></li>
            <li><a href="/account/addresses">Adressen anzeigen</a></li>
            <li class="is-current"><a href="/apps/subscription-customer/customer-portal/23857571103104/ai1raW5za2kubXlzaG9waWZ5LmNvbQ==" target="_blank">Meine Abonnements</a></li>
            <li><a href="/a/gifthero/mycards">Meine Giftcards</a></li>
            <li><a href="/account/logout" id="customer_logout_link">Abmelden</a></li>
          </ul>
        </div>
      `;
      
      const style = document.createElement('style');
      style.textContent = `
        .utterbond-subscriptions .sub-head {
          padding-top: 0 !important;
        }
        .subscription-portal-wrapper {
          display: grid;
          grid-template-columns: 1fr 3fr;
          gap: var(--gap);
          max-width: 80vw;
          margin: 40px auto;
        }
        .subscription-injected-sidebar ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
          .subscription-injected-sidebar p {
          font-family: 'Roboto Mono' !important;
          }
        .subscription-injected-sidebar a {
          display: block;
          padding: 8px 0;
          text-decoration: none;
          color: #333;
          font-family: 'Roboto Mono' !important;
        }
        .subscription-injected-sidebar .is-current a {
          font-weight: bold;
          color: var(--link-hover);
        }
        @media (max-width: 768px) {
          .subscription-portal-wrapper {
            grid-template-columns: 1fr;
            max-width: 100vw;
            margin: 20px;
          }
        }
      `;
      
      document.head.appendChild(style);
      wrapper.prepend(sidebar);
    }
  }
}

function injectSidebarToGiftHero() {
  if (window.location.pathname === '/a/gifthero/mycards') {
    const targetElement = document.getElementById('sc-account-giftcards');
    if (targetElement) {
      // Remove sc-hero-checker-container
      const checkerContainer = document.querySelector('.sc-hero-checker-container');
      if (checkerContainer) {
        checkerContainer.remove();
      }
      
      const sidebar = document.createElement('aside');
      sidebar.className = 'account-sidebar gifthero-injected-sidebar';
      sidebar.innerHTML = `
        <div class="desktop">
          <p class="account-sidebar__title strong">Mein Konto</p>
          <ul>
            <li><a href="/account">Bestellungen</a></li>
            <li><a href="/account/addresses">Adressen anzeigen</a></li>
            <li><a href="/apps/subscription-customer/customer-portal/23857571103104/ai1raW5za2kubXlzaG9waWZ5LmNvbQ==" target="_blank">Meine Abonnements</a></li>
            <li class="is-current"><a href="/a/gifthero/mycards">Meine Giftcards</a></li>
            <li><a href="/account/logout" id="customer_logout_link">Abmelden</a></li>
          </ul>
        </div>
        
        <div class="mobile">
          <collapsible-elements>
            <details data-collapsible>
              <summary data-collapsible-trigger>
                <p class="account-sidebar__title strong">
                  Mein Konto
                  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 24 24"><path d="M6 12h6m6 0h-6m0 0V6m0 6v6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 24 24"><path d="M6 12h12" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </p>
              </summary>
              <div data-collapsible-body>
                <div data-collapsible-content>
                  <ul>
                    <li><a href="/account">Bestellungen</a></li>
                    <li><a href="/account/addresses">Adressen anzeigen</a></li>
                    <li><a href="/apps/subscription-customer/customer-portal/23857571103104/ai1raW5za2kubXlzaG9waWZ5LmNvbQ==" target="_blank">Meine Abonnements</a></li>
                    <li class="is-current"><a href="/a/gifthero/mycards">Meine Giftcards</a></li>
                  </ul>
                </div>
              </div>
            </details>
          </collapsible-elements>
        </div>
      `;
      
      // Create balance check section
      const balanceSection = document.createElement('div');
      balanceSection.className = 'balance-check-section';
      balanceSection.innerHTML = `
        <h3>Du willst wissen, wie viel Guthaben du noch auf deiner Karte hast?</h3>
        <a href="https://www.j-kinski.de/pages/giftcard-abfrage" class="btn btn--solid btn--primary">Guthaben abfragen</a>
      `;
      
      const style = document.createElement('style');
      style.textContent = `
        .sc-hero-checker-container {
          display: none !important;
        }
        .account-sidebar {
          position: static !important;
        }
        #sc-account-giftcards {
          margin-block: 40px !important;
          display: grid;
          grid-template-columns: 1fr 3fr;
          align-items: start;
          gap: var(--gap);
          max-width: 80vw !important;
        }
        .gifthero-injected-sidebar {

        }
        .gifthero-injected-sidebar .account-sidebar__title {
          margin-bottom: 15px;
          font-weight: bold;
        }
        .gifthero-injected-sidebar ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .gifthero-injected-sidebar a {
          text-decoration: none;
          color: #333;
          padding-block: 8px;
          display: block;
        }
        .gifthero-injected-sidebar .is-current a {
          font-weight: bold;
          color: var(--link-hover);
        }
        .gifthero-injected-sidebar a:hover {
          color: var(--link-hover);
        }
        .gifthero-injected-sidebar .mobile {
          display: none;
        }
        .gifthero-injected-sidebar .desktop {
          display: block;
        }
        .balance-check-section {
          grid-column: 1 / -1;
          text-align: center;
          padding: 20px;
          margin-top: 20px;
        }
        .balance-check-section h3 {
          margin-bottom: 15px;
          color: #333;
          font-size: 1.6rem;
        }
        .balance-check-section .btn {
          display: inline-block;
          padding: 12px 24px;
          text-decoration: none;
          border-radius: 4px;
        }
        @media (max-width: 768px) {
          #sc-account-giftcards {
            grid-template-columns: 1fr;
          }
          .gifthero-injected-sidebar {
            width: 100%;
            margin-bottom: 20px;
          }
          .gifthero-injected-sidebar .desktop {
            display: none;
          }
          .gifthero-injected-sidebar .mobile {
            display: block;
          }
        }
      `;
      
      document.head.appendChild(style);
      targetElement.prepend(sidebar);
      targetElement.appendChild(balanceSection);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    modifySubscriptionLink();
    modifyGiftCardLink();
    injectSidebarToGiftHero();
    injectSidebarToSubscriptions();
  }, 700);
})

